// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d385fb57","260":"e3927074","344":"50fa8890","384":"206d34e1","408":"e3314449","547":"0b5c824b"}[chunkId] + ".chunk.js";
};